module.exports = __webpack_public_path__ + "img/table_bg03.b012676e.png";